module.exports = __webpack_public_path__ + "static/africoin-banner-02cef498586256efd5798346db35cf59.png";